import ElTable from './src/table'

export default ElTable



// WEBPACK FOOTER //
// ./src/public/components/el-table/index.js